// components/PinnedMessage.jsx
import {
  Box,
  Paper,
  Typography,
  Stack,
  Avatar,
  IconButton,
} from '@mui/material';
import { PushPin, Reply } from '@mui/icons-material';
import ImageDisplay from './ImageDisplay';
import { formatUTCToLocalTime, handleMentionClick } from '../utils/constants';

const PinnedMessage = ({ message, currentUser, onReply }) => {
  const isOwn = currentUser && message.user_id === currentUser.id;
  let pressTimer;
  const handleTouchStart = () => {
    pressTimer = setTimeout(() => {
      handleMentionClick(message.id); // 長按觸發
    }, 500); // 0.5 秒
  };
  const handleTouchEnd = () => {
    clearTimeout(pressTimer);
  };  
  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        backgroundColor: 'rgba(255, 215, 0, 0.1)',
        border: '2px solid #ffd700',
        borderRadius: 2,
        position: 'relative'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <PushPin sx={{ color: '#ffd700', mr: 1 }} />
        <Typography variant="caption" sx={{ color: '#b8860b', fontWeight: 'bold' }}>
          熱門消息 (被回覆 {message.replyCount || 0} 次)
        </Typography>
      </Box>
      
      <Box
        sx={{
          display: 'flex',
          justifyContent: isOwn ? 'flex-end' : 'flex-start',
        }}
      >
        <Box
          sx={{
            maxWidth: '75%',
            display: 'flex',
            flexDirection: isOwn ? 'row-reverse' : 'row',
            alignItems: 'flex-start',
            gap: 1,
          }}
        >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: isOwn ? 'success.main' : 'primary.main',
              fontSize: '0.875rem',
            }}
          >
            {message.username.charAt(0).toUpperCase()}
          </Avatar>
          
          <Paper
            sx={{
              backgroundColor: isOwn ? 'success.main' : 'primary.main',
              color: 'white',
              borderRadius: 2,
              p: 1.5,
              position: 'relative',
              maxWidth: '100%',
            }}
            onDoubleClick={() => handleMentionClick(message.id)}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.5 }}>
              <Typography variant="caption" sx={{ opacity: 0.8, fontWeight: 'bold' }}>
                {message.username}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.6, fontSize: '0.7rem' }}>
                {formatUTCToLocalTime(message.created_at)}
              </Typography>
            </Stack>
            
            {message.message_text && (
              <Typography 
                variant="body2" 
                sx={{ 
                  wordBreak: 'break-word',
                  whiteSpace: 'pre-wrap',
                  lineHeight: 1.4
                }}
              >
                {message.message_text}
              </Typography>
            )}
            
            {message.images && message.images.length > 0 && (
              <Stack direction="row" spacing={0.5} sx={{ mt: 1, flexWrap: 'wrap' }}>
                {message.images.map((img, index) => (
                  <ImageDisplay
                    key={index}
                    imageUrl={img}
                    alt={`圖片${index + 1}`}
                    maxWidth={200}
                    maxHeight={150}
                    onClick={(url) => window.open(url, '_blank')}
                  />
                ))}
              </Stack>
            )}
            
            {!isOwn && (
              <IconButton
                size="small"
                sx={{ 
                  mt: 1,
                  color: 'rgba(255,255,255,0.7)',
                  '&:hover': { color: 'rgba(255,255,255,0.9)' }
                }}
                onClick={() => onReply(message)}
              >
                <Reply fontSize="small" />
              </IconButton>
            )}
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default PinnedMessage;